<div id="main-content" *ngIf="authorizationUser ;  else loading"  class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent($event)">
  <form [formGroup]="authData" (ngSubmit)="onSubmit()">

    
    <div class = "max-width-750">
      <h1 class="bofa--heading is-4">Fair Credit Reporting Act disclosure and authorization</h1>

      <div [innerHTML]="authLanguage"></div>
      
      
      <div class = "margin-top-bottom" *ngIf="authorizationUser">
        <app-wet-signature formControlName="output" [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)"></app-wet-signature>
        <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
      </div>
      
      <h2 class="bofa--heading is-7">{{ fcraStatement }}</h2>

      
      <mat-checkbox formControlName="authorizeConsent" class="minor-check-padding" aria-required="true" required (focusout)="authorizeOnBlur()"
        (focusin)="authorizeOnFocus()">
        <mat-label><abbr title="required">* </abbr><span class = "white-space">Yes, I authorize Bank of
            America to obtain, where permitted, one or more consumer reports for employment purposes.</span>
        </mat-label>
      </mat-checkbox>
      <mat-error class = "margin-top"  *ngIf="authorizeConsent.hasError('invalid') && check"> Please check the
        box to agree to the above language</mat-error>
      

      <h2 class="bofa--heading is-7">By checking the box below you agree that notices, documents and communications may
        be provided electronically and will
        meet the requirements set forth under Federal and/or State law, and agree that a fax or photocopy of this
        authorization with my signature should be
        accepted with the same authority as the original.</h2>

      
      <mat-checkbox formControlName="fcraLegalRequirementsMet" class="minor-check-padding" aria-required="true" required (focusout)="legalOnBlur()"
        (focusin)="legalOnFocus()">
        <mat-label class="minor-radio-padding"><abbr title="required">* </abbr><span class="white-space">Yes, I agree that notices,
            documents and communications may be provided
            electronically and will meet the requirements
            set forth under Federal and/or State law, and agree that a fax or photocopy of this authorization with my
            signature should be accepted with the same
            authority as the original.</span>
        </mat-label>
      </mat-checkbox>
      <mat-error class = "margin-top" *ngIf="fcraLegalRequirementsMet.hasError('invalid') && checkTwo"> Please check the box to agree to the
        above language </mat-error>
      
      

      <div>
        <mat-form-field class="max-zoom margin-width-top-bottom" 
          hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="fcraApplicantSignedName" required maxlength="250">
          <mat-error>Please enter your full name</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom max-width-350">
          <mat-label>Date Signed</mat-label>
          <input value="{{ date }}" matInput disabled>
        </mat-form-field>
      </div>
    </div>
    
  </form>
</div>
<ng-template #loading>
  Loading Applicant User...
</ng-template>
